'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  user-select: none;\n  line-height: 1em;\n  vertical-align: middle;\n  cursor: ', ';\n  font-size: ', ';\n  height: ', ';\n  fill: ', ';\n'], ['\n  user-select: none;\n  line-height: 1em;\n  vertical-align: middle;\n  cursor: ', ';\n  font-size: ', ';\n  height: ', ';\n  fill: ', ';\n']);

exports.default = Icon;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _layout = require('../layout');

var _theme = require('../theme');

var _theme2 = _interopRequireDefault(_theme);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledIcon = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Inline)(_templateObject, function (props) {
  return props.interactive ? 'cursor' : 'inherit';
}, function (props) {
  return props.size + 'px';
}, function (props) {
  return props.size + 'px';
}, function (props) {
  return props.theme.colors[props.color];
});

function Icon(props) {
  var children = props.children,
      _props$size = props.size,
      size = _props$size === undefined ? _constants.DEFAULT_SIZE : _props$size,
      _props$color = props.color,
      color = _props$color === undefined ? _constants.DEFAULT_COLOR : _props$color,
      className = props.className,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? _theme2.default : _props$theme,
      title = props.title,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'size', 'color', 'className', 'onClick', 'theme', 'title']);


  return React.createElement(
    StyledIcon,
    (0, _extends3.default)({
      className: className,
      component: 'i',
      interactive: !!onClick,
      onClick: onClick,
      theme: theme,
      size: size,
      color: color,
      title: title
    }, otherProps),
    React.createElement(
      'svg',
      { width: size, height: size, 'aria-hidden': 'true' },
      React.createElement(
        'title',
        null,
        title ? title : children
      ),
      React.createElement('use', { xlinkHref: '#' + children })
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/icon/icon.js
// module id = 336
// module chunks = 114276838955818